export default __webpack_public_path__ + "static/media/Gardenshear.517aeba2.jpg";